import React, { useEffect, useState } from "react";

import "style/ModalStyles.css";
import MsgModal from "./MsgModal";
import { requestPost } from "utils/AxiosApi";
import Loader from "utils/Loader";

import { phoneHyphen } from "utils/CommonUtils";

const InquiryModal = (props: any) => {
  //모달창 open
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMsg, setModalMsg] = useState("");

  //loader
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    document.body.style.cssText = `
          position: fixed; 
          top: -${window.scrollY}px;
          overflow-y: scroll;
          width: 100%;`;
    return () => {
      const scrollY = document.body.style.top;
      document.body.style.cssText = "";
      window.scrollTo(0, parseInt(scrollY || "0", 10) * -1);
    };
  }, []);

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [text, setText] = useState("");

  const applyInquiry = async () => {
    setIsLoading(true);

    let data = await requestPost("/api/board/inquiry", {
      name: name,
      phone: phone,
      text: text,
    });

    if (data.result) {
      setModalOpen(true);
      setModalMsg("문의가 완료되었습니다.");
    } else {
      setModalOpen(true);
      setModalMsg("문의에 실패했습니다.");
    }
    setIsLoading(false);
  };

  const phoneValidate = (value: any) => {
    let phoenNumber = phoneHyphen(value);
    setPhone(phoenNumber);
  };

  const msgModalConfirm = () => {
    setModalOpen(false);
    props.setOpenModal(false);
  };

  return (
    <div className="modalBackground">
      <div className="modalContainer-edit-password">
        <span className="span-black-margin10" id="font-SCD6">
          문의하기
        </span>
        <br></br>
        <div className="termsBody" id="font-SCD3">
          <div
            className="display-center-margin-0"
            style={{ padding: "0 10px" }}
          >
            <div className="">
              <div className="span-gray-text-1">
                <span className="input-label">이름</span>
              </div>
              <input
                onChange={(e) => {
                  setName(e.target.value);
                }}
                className="input-form-w97p-40"
                type="text"
                name="name"
                value={name}
              ></input>
              <div className="span-gray-text-1">
                <span className="input-label">연락처</span>
              </div>
              <input
                onChange={(e) => {
                  phoneValidate(e.target.value);
                }}
                className="input-form-w97p-40"
                type="text"
                name="phone"
                value={phone}
                maxLength={13}
              ></input>
              <div className="span-gray-text-1">
                <span className="input-label">내용</span>
              </div>
              <textarea
                style={{ minHeight: "120px", resize: "none" }}
                onChange={(e) => {
                  setText(e.target.value);
                }}
                className="input-form-w97p-40"
                name="text"
                value={text}
              ></textarea>
            </div>
          </div>
        </div>
        <div className="mfooter">
          <div style={{ textAlign: "center", marginTop: "-18px" }}>
            <button
              className="terms-agree"
              id="font-SCD4"
              onClick={() => applyInquiry()}
            >
              제출
            </button>
            <button
              className="terms-cancel"
              onClick={() => props.setOpenModal(false)}
              id="font-SCD4"
            >
              취소
            </button>
          </div>
        </div>
      </div>
      {modalOpen && (
        <MsgModal
          setOpenModal={setModalOpen}
          modalMsg={modalMsg}
          modalConfirm={msgModalConfirm}
        ></MsgModal>
      )}
      {isLoading && <Loader isLoading={isLoading}></Loader>}
    </div>
  );
};

export default InquiryModal;
